module.exports = __webpack_public_path__ + "static/media/right-arrow.4dc5aa2a.svg";